import { css } from 'lit';

export const pricingPageStyles = css`
  .pricing-page {
    padding: 6rem 2rem 4rem;
    background: var(--sl-color-neutral-50, #f8fafc);
    min-height: 100vh;
  }

  .pricing-hero {
    max-width: 960px;
    margin: 0 auto 3rem;
    text-align: center;
    display: grid;
    gap: 1.25rem;
  }

  .pricing-hero h1 {
    font-size: 3rem;
    line-height: 1.1;
    color: var(--sl-color-neutral-900);
  }

  .pricing-hero p {
    font-size: 1.15rem;
    color: var(--sl-color-neutral-600);
    max-width: 720px;
    margin: 0 auto;
  }

  .pricing-grid {
    max-width: 1100px;
    margin: 0 auto;
    display: grid;
    gap: 2.5rem;
  }

  .pricing-cards {
    display: grid;
    gap: 1.5rem;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  }

  .pricing-card {
    display: grid;
    gap: 1rem;
    padding: 2.25rem 2rem;
    background: white;
    border-radius: 20px;
    border: 1px solid var(--sl-color-neutral-200);
    box-shadow: var(--sl-shadow-large, 0 30px 60px -20px rgba(15, 23, 42, 0.35));
  }

  .pricing-card.highlight {
    border: 2px solid var(--sl-color-primary-400, #60a5fa);
    box-shadow: var(--sl-shadow-x-large, 0 35px 70px -25px rgba(37, 99, 235, 0.45));
  }

  .pricing-card h2 {
    font-size: 1.75rem;
    margin: 0;
    color: var(--sl-color-neutral-900);
  }

  .pricing-price {
    font-size: 2.25rem;
    font-weight: 700;
    color: var(--sl-color-neutral-900);
  }

  .pricing-price span {
    font-size: 1rem;
    font-weight: 500;
    color: var(--sl-color-neutral-500);
  }

  .pricing-description {
    color: var(--sl-color-neutral-600);
  }

  .pricing-features {
    display: grid;
    gap: 0.5rem;
    padding-left: 1.25rem;
    color: var(--sl-color-neutral-600);
  }

  .pricing-actions {
    margin-top: 3rem;
    text-align: center;
  }

  .pricing-footer-note {
    margin-top: 1rem;
    color: var(--sl-color-neutral-500);
    font-size: 0.95rem;
  }

  @media (max-width: 768px) {
    .pricing-page {
      padding: 5.5rem 1.25rem 3rem;
    }

    .pricing-hero h1 {
      font-size: 2.4rem;
    }

    .pricing-card {
      padding: 1.75rem 1.5rem;
    }
  }
`;
